import * as actions from './actionsTypes';

const initialData = {
  loaderWorkFlowTasksList: false,
  loaderWorkFlowTaskList : false,
  saveLoaderWorkFlowTaskList: false,
  saveLoaderWorkFlowTaskListPosition: false,
  // workflowTasksListLength: 0,
  workflowTasksList: null,
  workflowTaskList: null,
  formErrorsWorkflowTaskList: '',
  errorWorkflowTaskList: '',
}

export default function WorkflowTaskListReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_WORKFLOWBLOCK_TASKS_LISTS:
      return {...state, loaderWorkFlowTasksList: action.payload}
    case actions.LOADING_WORKFLOWBLOCK_TASK_LIST:
      return {...state, loaderWorkFlowTaskList: action.payload}
    case actions.SAVE_LOADING_WORKFLOWBLOCK_TASK_LIST:
      return {...state, saveLoaderWorkFlowTaskList: action.payload}
    case actions.SAVE_LOADING_WORKFLOW_TASK_LIST_POSITION:
      return {...state, saveLoaderWorkFlowTaskListPosition: action.payload}
    case actions.GET_WORKFLOWBLOCK_TASKS_LIST:
      return {...state, workflowTasksList: action.payload}
    case actions.GET_WORKFLOWBLOCK_TASK_LIST:
      return {...state, workflowTaskList: action.payload}
    case actions.WORKFLOWBLOCK_TASK_LIST_FAIL:
      return {...state, errorWorkflowTaskList: action.payload}
    case actions.WORKFLOWBLOCK_TASK_LIST_FORM_FAIL:
      return {...state, formErrorsWorkflowTaskList: action.payload}
    default:
      return state
  }
}